export default [
  // pdf预览页
  {
    path: '/pdf',
    name: 'pdf',
    component(resolve) {
      require(['@/views/tools/pdf.vue'], resolve)
    }
  },
]